import React from 'react';
import './VideoMutedOverlay.scss';
import classnames from 'classnames';
var VideoMutedOverlayTextSize;
(function (VideoMutedOverlayTextSize) {
    VideoMutedOverlayTextSize["Mini"] = "mini";
    VideoMutedOverlayTextSize["Full"] = "full";
})(VideoMutedOverlayTextSize || (VideoMutedOverlayTextSize = {}));
;
const componentClass = 'video-muted-overlay';
export const VideoMutedOverlay = ({ text, textSize }) => {
    return <div className={classnames([componentClass, {
                [`${componentClass}__mini`]: textSize === VideoMutedOverlayTextSize.Mini,
                [`${componentClass}__full`]: textSize === VideoMutedOverlayTextSize.Full,
            }])}>
    {text}
  </div>;
};
